module.exports = __webpack_public_path__ + "static/img/caseImg9.360206c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg9.jpg
// module id = UPH2
// module chunks = 0